import baseURLv1 from '@/services/APIConfig';
import { set } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    me: {},
    translations: {},
    areTranslationsProcessed: false,
  },
  mutations: {
    set,
  },
  actions: {
    async loadCurrentTranslations({ commit }) {
      const response = await this.$axios.get(`${baseURLv1}/user/me/translation/`);

      commit('set', ['translations', response.data.data]);
    },
    async confirmTranslationsProcessed({ commit }) {
      commit('set', ['areTranslationsProcessed', true]);
    },
    async loadMe({ commit }) {
      const response = await this.$axios.get(`${baseURLv1}/user/me/`);

      commit('set', ['me', response.data.data]);
    },
    async updateMe({ commit }, { payload }) {
      const response = await this.$axios.patch(`${baseURLv1}/user/me/`, payload);

      commit('set', ['me', response.data.data]);
    },
    async updateOutOfOffice({ commit }, { startDate, startTime, endDate, endTime, replacementUserId }) {
      const response = await this.$axios.patch(`${baseURLv1}/user/me/`, {
        internal_profile: {
          start_date: startDate,
          start_time: startTime,
          end_date: endDate,
          end_time: endTime,
          out_of_office_replacement_id: replacementUserId,
        },
      });

      commit('set', ['me', response.data.data]);
    },
    async updateAvatar({ commit }, { payload }) {
      const fd = new FormData();
      fd.append('avatar', payload);

      const response = await this.$axios({
        method: 'patch',
        url: `${baseURLv1}/user/me/`,
        data: fd,
        config: {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      });

      commit('set', ['me', response.data.data]);
    },
  },
  getters: {
    isOutOfOffice: (state) => {
      return state.me.profile.start_date && state.me.profile.start_time && state.me.profile.end_date && state.me.profile.end_time && state.me.profile.out_of_office_replacement_id;
    },
  },
};
